import ModelTable from "./view/ModelTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LeasedEquipmentModel = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_leasedequipment_model_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewPermission) ? <ModelTable /> : ""}</>;
};

export default LeasedEquipmentModel;
